import { Button, COLOR_PALETTE, Stack } from '@inflearn/ds-react-next';
import GlareHover from './GlareHover';

interface GameStartScreenProps {
  onGameStart: () => void;
  children: React.ReactNode;
}

export const GameStartScreen = ({ onGameStart, children }: GameStartScreenProps) => {
  return (
    <Stack
      h="100%"
      align="center"
      styles={{
        root: { flexGrow: 1 },
      }}
    >
      <Stack
        gap="xs"
        justify="center"
        align="center"
        styles={{
          root: { flexGrow: 1 },
        }}
      >
        {children}
      </Stack>
      <GlareHover
        height="50px"
        width="100%"
        glareOpacity={0.5}
        background={COLOR_PALETTE.infgreen[6]}
        borderRadius="32px"
      >
        <Button
          size="lg"
          radius="xl"
          onClick={onGameStart}
          w={'100%'}
          styles={{
            root: {
              background: 'transparent',
              '&:hover': {
                background: 'transparent',
              },
            },
          }}
        >
          START
        </Button>
      </GlareHover>
    </Stack>
  );
};
